"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _pragma = require("../../../pragma");

var React = _interopRequireWildcard(require("react"));

var _ = require("../..");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

/**
 * The InsightLineChart component renders a noninteractive line graph and a
 * small set of accompanying content to add context. As an example, it's used on
 * the 'My Performance' page to show net total profits and losses.
 *
 * If multiple lines of content need to be rendered for the title,value, or
 * explanation props, you may pass in pre-formatted JSX (eg, multiple `Text`
 * components).
 */
const InsightLineChart = ({
  data = [],
  explanation,
  title,
  value,
  graphHeight = 128,
  ...otherProps
}) => (0, _pragma.createFelaElement)(_.View, _extends({
  flexDirection: "column"
}, otherProps), (0, _pragma.createFelaElement)(_.Text, {
  children: title
}), (0, _pragma.createFelaElement)(_.View, {
  flex: true,
  margin: ['small', 'none', 'xxxlarge']
}, (0, _pragma.createFelaElement)(_.LineGraph, {
  data: data,
  height: graphHeight,
  responsive: true
})), (0, _pragma.createFelaElement)(_.View, {
  flexDirection: "column",
  gap: "xsmall"
}, (0, _pragma.createFelaElement)(_.Text, {
  as: "div",
  children: value,
  variant: "bodyBold"
}), (0, _pragma.createFelaElement)(_.Text, {
  as: "div",
  children: explanation,
  variant: "meta"
})));

InsightLineChart.displayName = 'InsightLineChart';
var _default = InsightLineChart;
exports.default = _default;
//# sourceMappingURL=InsightLineChart.js.map